import React, { useEffect, useState } from 'react';
import { Link, Alert } from 'mesh-component-library';
import useAppStateData from '../../../redux/hooks/useAppStateData';
import { datadogRum } from '@datadog/browser-rum';
import { ErrorType } from '../../../env/constants/errors';
import { setErrorMessage } from '../../../redux/reducers/appStateSlice/appStateSlice';
import { useDispatch } from 'react-redux';

const ValidationErrorExtraHelpToast: React.FC = () => {
    const dispatch = useDispatch();
    const { errorMessage } = useAppStateData();

    const [isActive, setIsActive] = useState(false);
    useEffect(() => {
        if (errorMessage) {
            datadogRum.addError(new Error(ErrorType.VALIDATION_ERROR), {
                type: ErrorType.VALIDATION_ERROR,
                reason: errorMessage,
            });
            setIsActive(true);
        } else {
            setIsActive(false);
        }
    }, [errorMessage]);

    const onDismiss = (): void => {
        setIsActive(false);
        dispatch(setErrorMessage(''));
    };

    return (
        <div
            data-testid="toast-container"
            className={isActive ? 'toast-container--active' : 'toast-container--inactive'}
        >
            <Alert
                className={'toast-header'}
                isActive={isActive}
                onDismiss={() => onDismiss()}
                variant="critical"
                dismissible={true}
                size="md"
                title={<div className={'toast-title'}>
                    No match found
                </div>}
            >
                <Alert.Body className={'toast-body'}>
                    Check your details and try again or reach out to your Claim Contact in
                    <Link href="https://www.allstate.com/claims/track-claim.aspx" style={{ color: '#013aa9' }}>
                        MyClaim.
                    </Link>
                </Alert.Body>
            </Alert>
        </div>
    );
};

export default ValidationErrorExtraHelpToast;
